function Menu(){

    console.log("menu");

    var self = this;

    this.menuOpen = false;

    function hideMenu(){

        $('.menu-wrapper').removeClass("menu-open");
    }

    $('.main-navbar .navbar-toggle').click(function(e) {

       console.log('click');

       if(self.menuOpen){

           console.log("close");

           //TweenMax.set(".menu-wrapper", {css:{display:"none"}});


           TweenMax.set(".main-navbar .navbar-toggle .open-menu", {css:{display:"block"}});
           TweenMax.set(".main-navbar .navbar-toggle .close-menu", {css:{display:"none"}});

           //TweenMax.set(".menu-wrapper", {left:"100%"});
           TweenMax.to(".menu-wrapper", 0.5, {left:"100%", onComplete: hideMenu});

       } else {

           console.log("open");

           //TweenMax.set(".menu-wrapper", {css:{display:"block"}});
           $('.menu-wrapper').addClass("menu-open");
           TweenMax.set(".main-navbar .navbar-toggle .open-menu", {css:{display:"none"}});
           TweenMax.set(".main-navbar .navbar-toggle .close-menu", {css:{display:"block"}});

           TweenMax.set(".menu-wrapper", {left:"100%"});
           TweenMax.to(".menu-wrapper", 0.5, {left:"0%"});
       }

        self.menuOpen =! self.menuOpen;

    });

    $(window).resize(function (){

        if(!self.menuOpen){

            TweenMax.to(".menu-wrapper", 0.5, {left:"0%"});
        }

        //TweenMax.to(".menu-wrapper", 0.5, {left:"0%"});

    });

}
